import React, { useCallback, useState } from 'react'
import block from 'bem-cn'

import { IGetUserPromotionsFilters } from 'shared/models/BonusSystem'
import { IUserPromotion } from 'shared/models/Promotion'

import { BackCard, FrontCard } from '../Cards'

import './BonusItem.scss'

const b = block('bonus-item')

type IBonusItemProps = {
  promotion: IUserPromotion
  filters: IGetUserPromotionsFilters
}

const BonusItem: React.FC<IBonusItemProps> = ({ promotion, filters }) => {
  const [backSide, setBackSide] = useState(false)

  const onInfoClickHandler = useCallback(() => {
    setBackSide(prev => !prev)
  }, [])

  return (
    <div className={b()}>
      <div className={b('container', { back: backSide })}>
        <FrontCard promotion={promotion} onInfoClick={onInfoClickHandler} filters={filters} />
        <BackCard promotion={promotion} onInfoClick={onInfoClickHandler} />
      </div>
    </div>
  )
}

export default BonusItem
